import axios from "axios";
import Common from '@/common.js'


const state = {
    orders:{},
    orderDetails:{}
};
const getters = {
    Orders: state => state.orders, OrderDetails: state => state.orderDetails,
};
const actions = {
    async getOrders({commit},userId){
        var url = Common.getApiCallUrl("Orders/OrderController::GetUserOrders");
        var config = Common.getRequestHeader();
        const response = await axios.post(url,{"user_id":userId},config);
        var data = Common.mapResponse(response.data)
        commit("setOrders",data);
   },
   async getOrderDetails({commit},orderId){
    var url = Common.getApiCallUrl("Orders/OrderController::GetOrderDetails");
    var config = Common.getRequestHeader();
    const response = await axios.post(url,{"order_id":orderId},config);
    var data = Common.mapResponse(response.data)
    commit("setOrderDetails",data);
}

};
const mutations = {
    setOrders:(state, orders) => (state.orders = JSON.parse(orders)),
    setOrderDetails:(state, orderDetails) => (state.orderDetails = JSON.parse(orderDetails))
};

export default{
    state,
    getters,
    actions,
    mutations
};